var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"yeti-panel",attrs:{"role":"tabpanel","id":'panel' + _vm.index,"aria-labelledby":'tab' + _vm.index,"hidden":_vm.activeTab !== _vm.index}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }